import Vue from "vue";

import Buefy from "buefy";
import "buefy/dist/buefy.css";

import VueTheMask from "vue-the-mask";
import Vue2Filters from "vue2-filters";
import VuePageTransition from "vue-page-transition";
import Notifications from "vue-notification";

import app from "./app/app";
import filters from "./app/shared/filters";
import router from "./app/app-routes";
import store from "./app/app-state";
import vuetify from "./plugins/vuetify";
import Toaster from "./plugins/toaster";

import "./styles/main.scss";
import "@mdi/font/css/materialdesignicons.css";
import "vue-tel-input/dist/vue-tel-input.css";

Vue.config.productionTip = false;

Vue.use(filters);
Vue.use(Notifications);
Vue.use(Buefy);
Vue.use(Toaster);
Vue.use(VueTheMask);
Vue.use(Vue2Filters);
Vue.use(VuePageTransition);

export default new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(app),
}).$mount("#app");
